const {
  parsePhoneNumberFromString,
  getCountries,
  getCountryCallingCode,
  isSupportedCountry,
} = libphonenumber;

// Input elements
const emailOrPhoneInputEl = document.getElementById("recipient-email-or-phone");
const countryCodeEl = document.getElementById("country-code");
const countrySelectorEl = document.getElementById("country-selector");
const countryFlagButtonEl = document.getElementById("country-flag-button");
const flagEmojiEl = document.getElementById("flag-emoji");

// Error message elements
const errorMessageEmailEl = document.getElementById(
  "email-or-phone-error-email",
);
const errorMessagePhoneEl = document.getElementById(
  "email-or-phone-error-phone",
);
const errorMessageGeneralEl = document.getElementById(
  "email-or-phone-error-general",
);

// Get country code from the select element (single source of truth)
function getCurrentCountryCode() {
  return countryCodeEl.value || getInitialCountryCode();
}

// Populate country dropdown with all countries and their calling codes e.g. "United States (+1)""
function populateCountryDropdown() {
  const countries = getCountries(); // e.g. ["US", "UK", "CA", ...]
  const displayNames = new Intl.DisplayNames(["en"], { type: "region" });

  // Clear existing options
  countryCodeEl.innerHTML = "";

  // Create country data array with display names for sorting
  const countryData = [];
  countries.forEach((country) => {
    try {
      const callingCode = getCountryCallingCode(country);
      const countryName = displayNames.of(country); // e.g. "United States"
      countryData.push({
        code: country,
        name: countryName,
        callingCode: callingCode,
        flag: countryCodeToFlag(country),
      });
    } catch (error) {
      // Skip countries that don't have calling codes
      console.warn(`Could not get calling code for ${country}:`, error);
    }
  });

  // Sort countries alphabetically by display name
  countryData.sort((a, b) => a.name.localeCompare(b.name));

  // Create options for each country
  countryData.forEach((country) => {
    const option = document.createElement("option");
    option.value = country.code;
    option.textContent = `${country.name} (+${country.callingCode})`;
    // Store the flag emoji as a data attribute
    option.setAttribute("data-flag", country.flag);
    countryCodeEl.appendChild(option);
  });
}

// Convert country code to flag emoji
function countryCodeToFlag(countryCode) {
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
}

// Single function to update all country code related UI
function updateCountryCode(newCountryCode) {
  console.log("Updating country code to:", newCountryCode);
  countryCodeEl.value = newCountryCode;
  // Update flag display
  const flag = countryCodeToFlag(newCountryCode);
  flagEmojiEl.textContent = flag;
}

function toggleCountryDropdown() {
  countryCodeEl.focus();
  countryCodeEl.click();
}

// Main initialization function
function main() {
  populateCountryDropdown();
  updateCountryCode(getInitialCountryCode());
  setupEventListeners();
}

function setupEventListeners() {
  emailOrPhoneInputEl.addEventListener("input", handleEmailOrPhoneInput);
  emailOrPhoneInputEl.addEventListener("blur", handleEmailOrPhoneInputBlur);
  countryCodeEl.addEventListener("change", handleCountryCodeChange);
  countryFlagButtonEl.addEventListener("click", handleCountryFlagButtonClick);
}

// Initialize everything when page loads
main();

function handleEmailOrPhoneInput(e) {
  const userInput = e.target.value;
  resetErrorMessages();
  const inputType = ribbonUtils.isEmailOrPhone(userInput);
  renderInputType(inputType);
}

function handleEmailOrPhoneInputBlur(e) {
  const userInput = e.target.value;
  const inputType = ribbonUtils.isEmailOrPhone(userInput);

  resetErrorMessages();

  if (inputType === "email") {
    validateEmail(userInput);
  } else if (inputType === "phone") {
    validatePhoneNumberOnBlur(userInput);
  } else {
    emailOrPhoneInputEl.style.borderColor = "red";
    errorMessageGeneralEl.style.display = "block";
  }
}

function resetErrorMessages() {
  emailOrPhoneInputEl.style.borderColor = "";
  errorMessageEmailEl.style.display = "none";
  errorMessagePhoneEl.style.display = "none";
  errorMessageGeneralEl.style.display = "none";
}

function validatePhoneNumberOnBlur(userInput) {
  const phoneNumber = parsePhoneNumberFromString(
    userInput,
    getCurrentCountryCode(),
  );
  if (phoneNumber?.country) {
    updateCountryCode(phoneNumber.country);
  }
  if (!phoneNumber?.isValid()) {
    errorMessagePhoneEl.style.display = "block";
  } else {
    errorMessagePhoneEl.style.display = "none";
  }
}

function handleCountryCodeChange(e) {
  resetErrorMessages();

  updateCountryCode(e.target.value);
  const input = emailOrPhoneInputEl.value;
  const inputType = ribbonUtils.isEmailOrPhone(input);
  validateInput(input, inputType);
}

function handleCountryFlagButtonClick() {
  toggleCountryDropdown();
}

function renderInputType(inputType) {
  if (inputType === "email") {
    emailOrPhoneInputEl.type = "text";
    countrySelectorEl.style.display = "none";
  } else if (inputType === "phone") {
    emailOrPhoneInputEl.type = "text";
    countrySelectorEl.style.display = "block";
    const flag = countryCodeToFlag(getCurrentCountryCode());
    flagEmojiEl.textContent = flag;
  }
}

function getInitialCountryCode() {
  const lang = navigator.language || "en-US";
  let countryCode = new Intl.Locale(lang).region || "US";
  if (!isSupportedCountry(countryCode)) {
    console.log("Not supported country", countryCode);
    countryCode = "US";
  }
  const upperCaseCountryCode = countryCode.toUpperCase();
  return upperCaseCountryCode;
}

function validateInput(input, inputType) {
  if (inputType === "email") {
    return validateEmail(input);
  } else if (inputType === "phone") {
    return validatePhoneNumber(input, getCurrentCountryCode());
  } else {
    errorMessageGeneralEl.style.display = "block";
    return false;
  }
}

function validatePhoneNumber(number, countryCode) {
  const isValid = ribbonUtils.validatePhoneNumber(number, countryCode);
  if (!isValid) {
    errorMessagePhoneEl.style.display = "block";
  }
  return isValid;
}

function validateEmail(email) {
  const isValid = ribbonUtils.validateEmail(email);
  if (!isValid) {
    errorMessageEmailEl.style.display = "block";
  }
  return isValid;
}
